import React, { useState, useEffect } from 'react';
import './ClientForm.css';

const ClientForm = ({ initialData, onSave, onCancel }) => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    address: '',
    personalMessage: '',
    files: []
  });
  
  const [newFiles, setNewFiles] = useState([]);
  const [errors, setErrors] = useState({});
  
  useEffect(() => {
    if (initialData) {
      setFormData({
        name: initialData.name || '',
        phone: initialData.phone || '',
        email: initialData.email || '',
        address: initialData.address || '',
        personalMessage: initialData.personalMessage || '',
        files: initialData.files || []
      });
    }
  }, [initialData]);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Limpiar error del campo cuando el usuario escribe
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: null
      }));
    }
  };
  
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setNewFiles(prev => [...prev, ...files]);
  };
  
  const removeFile = (index, isExisting = false) => {
    if (isExisting) {
      // Remover archivo existente
      setFormData(prev => ({
        ...prev,
        files: prev.files.filter((_, i) => i !== index)
      }));
    } else {
      // Remover archivo nuevo
      setNewFiles(prev => prev.filter((_, i) => i !== index));
    }
  };
  
  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.name.trim()) {
      newErrors.name = 'El nombre es obligatorio';
    }
    
    if (!formData.phone.trim()) {
      newErrors.phone = 'El teléfono es obligatorio';
    } else if (!/^[0-9]{6,15}$/.test(formData.phone.replace(/\D/g, ''))) {
      newErrors.phone = 'Formato de teléfono inválido';
    }
    
    if (formData.email && !/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Formato de email inválido';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (validateForm()) {
      // Preparar datos para enviar, incluyendo archivos nuevos
      const clientData = {
        ...formData,
        newFiles
      };
      
      onSave(clientData);
    }
  };
  
  return (
    <form className="client-form" onSubmit={handleSubmit}>
      <div className="form-section">
        <div className="form-group">
          <label htmlFor="name">Nombre</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className={errors.name ? 'error' : ''}
          />
          {errors.name && <div className="error-message">{errors.name}</div>}
        </div>
        
        <div className="form-group">
          <label htmlFor="phone">Celular</label>
          <input
            type="text"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            className={errors.phone ? 'error' : ''}
          />
          {errors.phone && <div className="error-message">{errors.phone}</div>}
        </div>
        
        <div className="form-group">
          <label htmlFor="email">Mail</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className={errors.email ? 'error' : ''}
          />
          {errors.email && <div className="error-message">{errors.email}</div>}
        </div>
        
        <div className="form-group">
          <label htmlFor="address">Dirección</label>
          <input
            type="text"
            id="address"
            name="address"
            value={formData.address}
            onChange={handleChange}
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="personalMessage">Mensaje personalizado</label>
          <textarea
            id="personalMessage"
            name="personalMessage"
            value={formData.personalMessage}
            onChange={handleChange}
            rows={5}
          />
        </div>
      </div>
      
      <div className="form-section">
        <div className="form-group files-group">
          <label>Archivos adjuntos</label>
          
          <div className="file-list">
            {/* Archivos existentes */}
            {formData.files && formData.files.map((file, index) => (
              <div key={`existing-${index}`} className="file-item">
                <span className="file-name">{file.name}</span>
                <button 
                  type="button" 
                  className="remove-file"
                  onClick={() => removeFile(index, true)}
                >
                  ×
                </button>
              </div>
            ))}
            
            {/* Archivos nuevos */}
            {newFiles.map((file, index) => (
              <div key={`new-${index}`} className="file-item">
                <span className="file-name">{file.name}</span>
                <button 
                  type="button" 
                  className="remove-file"
                  onClick={() => removeFile(index)}
                >
                  ×
                </button>
              </div>
            ))}
          </div>
          
          <div className="file-upload">
            <input
              type="file"
              id="files"
              onChange={handleFileChange}
              multiple
              style={{ display: 'none' }}
            />
            <button
              type="button"
              className="upload-button"
              onClick={() => document.getElementById('files').click()}
            >
              + Agregar archivo
            </button>
          </div>
        </div>
      </div>
      
      <div className="form-actions">
        <button 
          type="button" 
          className="cancel-button"
          onClick={onCancel}
        >
          Cancelar
        </button>
        
        <button 
          type="submit" 
          className="save-button"
        >
          Guardar
        </button>
      </div>
    </form>
  );
};

export default ClientForm;